import React, { useState } from 'react';
import axios from 'axios';
import TypeWriter from '../components/TypeWriter';
import './Decrypt.css';

const Decrypt = () => {
  const [encryptedMessage, setEncryptedMessage] = useState('');
  const [decryptedMessage, setDecryptedMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [copySuccess, setCopySuccess] = useState(false);

  const handleDecrypt = async () => {
    if (!encryptedMessage.trim()) {
      setError('Please enter an encrypted message to decrypt');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const response = await axios.post('https://bharathchilaka-test.hf.space/api/decrypt', {
        encrypted_message: encryptedMessage.trim(),
      });

      if (response.data.decrypted_message) {
        setDecryptedMessage(response.data.decrypted_message);
        setSuccess('Message decrypted successfully!');
      } else {
        setError('No decrypted message received from server');
      }
    } catch (err) {
      console.error('Decryption error:', err);
      if (err.response?.data?.error) setError(err.response.data.error);
      else if (err.code === 'ECONNREFUSED') setError('Cannot connect to server. Please check your internet connection.');
      else setError('Failed to decrypt message. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const clearAll = () => {
    setEncryptedMessage('');
    setDecryptedMessage('');
    setError('');
    setSuccess('');
    setCopySuccess(false);
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(decryptedMessage);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <div className="decrypt-page">
      <div className="container">
        <div className="decrypt-header">
          <h1>
            <TypeWriter 
              text="Decrypt Messages" 
              speed={90} 
              cursorColor="white"
            />
          </h1>
          <p>Decrypt your secure messages with GestureSpeak's advanced decryption system</p>
        </div>

        <div className="input-section">
          <h2 className="decrypt-section-heading">Encrypted Message</h2>
          <textarea
            value={encryptedMessage}
            onChange={(e) => setEncryptedMessage(e.target.value)}
            placeholder="Paste your encrypted message here..."
            className="encrypted-input"
            rows="6"
          />
          <div className="input-actions">
            <button
              className={`btn btn-primary ${!encryptedMessage.trim() ? 'btn-disabled' : ''}`}
              onClick={handleDecrypt}
              disabled={!encryptedMessage.trim() || loading}
            >
              {loading ? 'Decrypting...' : ' Decrypt Message'}
            </button>
            <button className="btn btn-secondary" onClick={clearAll}>
               Clear All
            </button>
          </div>
        </div>

        {decryptedMessage && (
          <div className="result-section fade-in">
            <h2>Decrypted Message</h2>
            <div className="decrypted-container">
              <textarea value={decryptedMessage} readOnly className="decrypted-output" rows="6" />
              <button
                className={`btn copy-btn ${copySuccess ? 'copy-success' : ''}`}
                onClick={handleCopy}
              >
                {copySuccess ? 'Copied!' : 'Copy'}
              </button>
            </div>
          </div>
        )}

        {error && <div className="status-message error fade-in">{error}</div>}
        {success && <div className="status-message success fade-in">{success}</div>}
      </div>
    </div>
  );
};

export default Decrypt;
